import request from '@/utils/request'

export const login = (data: any) =>
  request({
    url: '/auth/signin',
    method: 'post',
    data: {
      email: data.email,
      password: data.password,
      provider: 'Admin'
    }
  })
